import { Box, Column } from "@hightouch/htui";

import { Navigate, NoContextOutlet } from "src/router";
import { useResourcePermission } from "src/components/permission/use-resource-permission";
import { PageSpinner } from "src/components/loading";

import { CepTermsOfService } from "./components/cep-tos";

const ND_VIEW_PERMISSION = {
  v2: {
    resource: "workspace" as const,
    grant: "can_view_native_delivery" as const,
  },
};

export function CepLayout() {
  const { isPermitted, isLoading } = useResourcePermission(ND_VIEW_PERMISSION);

  if (isLoading) {
    return <PageSpinner />;
  }

  if (!isPermitted) {
    return <Navigate to="/" replace />;
  }

  return (
    <Column h="100%" minH={0}>
      <CepTermsOfService />
      <Box flex={1} minH={0}>
        <NoContextOutlet />
      </Box>
    </Column>
  );
}
